import React from 'react'

const debug = false
// const debug = "FieldDateRange_PickerValueNotEmpty"

export default function FieldDateRange_PickerValueNotEmpty(props:any) {
    debug && console.log(debug, 'render')

    const onDeleteClick = () => {
        props.onChange(null)
    }

    let showClearButton: boolean = props.field.clearButton
    if (!_.isNil(props.configOptions?.showClearButton)) {
        showClearButton = props.configOptions.showClearButton
    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-with-delete-on-hover", props.className)}>
                <div className="ui5-field-dropdown-inline-editable with-delete txt-truncate" onClick={props.onClick}>
                    <div className="txt-truncate">
                        {props.field.getDisplayValue(props.value)}
                    </div>
                </div>

                {showClearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
            </div>

            {props.children}
        </React.Fragment>
    )
}
